module.exports = __webpack_public_path__ + "img/img-direct.1f618847.png";